import React, { createContext, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  HistoryContextProviderDefaultProps,
  HistoryContextProviderPropTypes,
} from './HistoryContextProvider.proptypes';

const HistoryContext = createContext();

const MAX_HISTORY_LENGTH = 50;

export const HistoryContextProvider = ({ children }) => {
  const history = useHistory();

  const [historyQueue, setHistoryQueue] = useState([history.location]);

  useEffect(() => {
    const unlisten = history.listen((location) => {
      setHistoryQueue((prevQueue) => {
        const newQueue = [location, ...prevQueue];

        if (newQueue.length > MAX_HISTORY_LENGTH) {
          newQueue.pop();
        }

        return newQueue;
      });
    });

    return () => unlisten();
  }, [history]);

  return (
    <HistoryContext.Provider value={{ historyQueue }}>
      {children}
    </HistoryContext.Provider>
  );
};

HistoryContextProvider.defaultProps = {
  ...HistoryContextProviderDefaultProps,
};

HistoryContextProvider.propTypes = {
  ...HistoryContextProviderPropTypes,
};

export const useHistoryContext = () => useContext(HistoryContext);
